import React from "react";
import { IoIosFlash } from "react-icons/io";
import { FaCheck, FaUsers, FaBuilding } from "react-icons/fa";
import { MdHome } from "react-icons/md";
import { BsHouseDownFill } from "react-icons/bs";
import { FaLightbulb, FaLocationDot } from "react-icons/fa6";

function WhyChooseUs() {
  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt">Why People Choose HomesDekho</p>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="why-choose-us-review-div">
                <div className="review-content-div">
                  <h3 className="review-content-div-heading">
                    Unmatched Selection
                  </h3>
                  <p className="content-para">
                    At HomesDekho, experience the perfect blend of cutting-edge
                    architecture, smart design, and energy-efficient living. We
                    offer the best flats in Mumbai, complete with premium
                    amenities and exceptional value. Discover luxury flats that
                    are not only stylish but also a secure investment for the
                    future.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mobile-margin">
              <div className="why-choose-us-review-div">
                <div className="review-content-div">
                  <h3 className="review-content-div-heading">
                    Homebuyers Trust Us
                  </h3>
                  <p className="content-para">
                    Owning a home is the foundation of lasting wealth, and trust
                    is where it begins. That's why every property for sale in
                    Mumbai, by Homesdekho is crafted by top designers, with
                    attention to every detail. From peaceful hill views to wide
                    balconies and timeless interiors, our homes are built to
                    deliver not just luxury but lasting value.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="why-choose-us-review-div">
                <div className="review-content-div">
                  <h3 className="review-content-div-heading">
                    Why Sellers Choose us
                  </h3>
                  <p className="content-para">
                    When it comes to selling property, having a trusted partner
                    matters. That's why homeowners choose HomesDekho - an
                    end-to-end real estate solution trusted for years across
                    Mumbai, Pune, and nearby areas. With countless listings,
                    sellers know their property is in good hands.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mobile-margin">
              <div className="why-choose-us-review-div">
                <div className="review-content-div">
                  <h3 className="review-content-div-heading">
                    Expert Guidance
                  </h3>
                  <p className="content-para">
                    At HomesDekho, we're here to help you find a property that
                    truly fits your needs. Whether it's a dream home or a
                    residential plot. Trusted by both buyers and sellers, our
                    expert team works tirelessly every day to make your property
                    journey smooth, transparent, <br /> and stress-free.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="what-we-offer-section mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt text-center">What We Offer</p>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4">
              <h2 className="subheading-txt">
                Offering You More Than Just Real Estate
              </h2>
              <p className="mt-3 content-para">
                HomesDekho is trusted by buyers and sellers alike for delivering
                the best service in the market. Whether you're looking for flats
                in Mumbai, flats in Navi Mumbai, or a residential property, our
                experts are here to help you every step of the way. We work with
                top developers to bring you luxurious yet affordable options to
                buy property in Mumbai. From site visits to final deals, we
                ensure a smooth and satisfying experience.
              </p>
              <div className="row text-center">
                <div className="col-md-4 col-6">
                  <p className="review-content-div-heading">Happy Clients</p>
                  <p className="review-content-div-heading">3000+</p>
                </div>
                <div className="col-md-4 col-6">
                  <p className="review-content-div-heading">Reputed Builder</p>
                  <p className="review-content-div-heading">150+</p>
                </div>
                <div className="col-md-4 col-12">
                  <p className="review-content-div-heading">Awards</p>
                  <p className="review-content-div-heading">200+</p>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">
                  <div className="why-choose-us-review-div">
                    <div className="review-content-div">
                      <div className="review-content-div-icon">
                        <BsHouseDownFill />
                        <h2 className="subheading-txt">
                          Affordable Properties
                        </h2>
                        <p>
                          Find budget-friendly housing options that suit your
                          needs without compromising on quality.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mobile-margin">
                  <div className="why-choose-us-review-div">
                    <div className="review-content-div">
                      <div className="review-content-div-icon">
                        <FaLightbulb />
                        <h2 className="subheading-txt">Innovative Designs</h2>
                        <p>
                          Experience homes built with modern architecture,
                          smartly designed spaces for everyday comfort.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <div className="why-choose-us-review-div">
                    <div className="review-content-div">
                      <div className="review-content-div-icon">
                        <FaCheck />
                        <h2 className="subheading-txt">
                          Reliability & Quality
                        </h2>
                        <p>
                          HomesDekho stands for trusted service and top-tier
                          construction — built to last, built for you.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mobile-margin">
                  <div className="why-choose-us-review-div">
                    <div className="review-content-div">
                      <div className="review-content-div-icon">
                        <IoIosFlash />
                        <h2 className="subheading-txt">Fastest Service</h2>
                        <p>
                          We ensure quick, reliable <br /> service so you can
                          find or sell your property without delays.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="subheading-txt">Homesdekho Here For You</h2>
              <p className="mt-3 content-para">
                We understand how exhausting house hunting can be, but you don't
                have to do it alone. At HomesDekho, we're with you every step of
                the way, from your very first search to sealing the final deal.
                All you need to do is explore HomesDekho, and we'll take care of
                the rest.
              </p>
            </div>
          </div>
          <div className="row text-center mt-5">
            <div className="col-md-3 col-6">
              <div className="review-content-div-icon">
                <FaLocationDot />
                <h3 className="mt-3 fw-bold">3+</h3>
                <p>Location</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="review-content-div-icon">
                <FaUsers />
                <h3 className="mt-3 fw-bold">50+</h3>
                <p>Sales Support</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="review-content-div-icon">
                <MdHome />
                <h3 className="mt-3 fw-bold">2500+</h3>
                <p>Residential Property</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="review-content-div-icon">
                <FaBuilding />
                <h3 className="mt-3 fw-bold">50+</h3>
                <p>Commercial property</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default WhyChooseUs;
